import React, { useContext, useEffect, useState } from 'react';

import { Props } from './BCResult.types';
import { Styled } from './BCResult.styles';
import { PageHeader } from '../components/PageHeader';
import { putRequest, secureRequest } from '../../../../utils/request';
import { bcContext } from '../context';
import {
  Data,
  ImageFile,
  Task,
  Ticket,
} from '../../ControllerTask/BCResult/BCResult.types';
import { context } from './context';
import { Page } from '../components/Page';
import { GainedTickets } from './GainedTickets';
import { Vehicles } from './Vehicles';
import { EditVehicle } from './EditVehicle';
import { actions } from '../../../../reducer/app';
import { useHistory } from 'react-router';
import { BackButton, LogoutButton } from '../components/NavigationButton';
import {Statuses} from "../../../components/UI/Status";
import PrimaryButton from 'views/components/UI/PrimaryButton';

export const BCResult: React.FC<Props> = () => {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [images, setImages] = useState<ImageFile[]>([]);
  const [resultTask, setResultTask] = useState<Task | null>(null);
  const [editingVehicleIndex, setEditingVehicleIndex] = useState<number | null>(
    null
  );

  const [vehicles, setVehicles] = useState<number[]>([]);
  const [routes, setRoutes] = useState<string[]>([]);

  const { task } = useContext(bcContext);

  const history = useHistory();
  useEffect(() => {
    if (task) {
      const request = async () => {
        const data = await secureRequest<Data>(
          '/api/v1/pass/controllertask/result/' + task.id
        );

        if (data) {
          const { tickets, files, task,vehicles, routes } = data;
          setTickets(tickets);
          setImages(files);
          setResultTask(task);
          setVehicles(vehicles);
          setRoutes(routes);
        }
      };
      request();
    }
  }, [task]);

  const onSave = async () => {
    if (resultTask) {
      await putRequest('api/v1/pass/controllertask/status?ids=' + resultTask.id)({
        status: Statuses.closed,
      });
      await putRequest(`/api/v1/pass/controllertask/result/${resultTask.id}`)({
        check_tickets: resultTask.check_tickets,
        check_vehicles: resultTask.check_vehicles,
      });
      history.goBack();
    }
  };

  let body = (
    <>
      {task && <h2>Наряд задание №{task.id}</h2>}
      <GainedTickets />
      <Vehicles />
      <PrimaryButton onClick={onSave}>
        Завершение выполнения отчета
      </PrimaryButton>
    </>
  );

  let backAction = () => history.push('/bc');
  if (editingVehicleIndex !== null) {
    backAction = () => setEditingVehicleIndex(null);
    body = <EditVehicle />;
  }

  return (
    <context.Provider
      value={{
        images,
        tickets,
        resultTask,
        setResultTask,
        setEditingVehicleIndex,
        editingVehicleIndex,
        vehicles,
        routes,
      }}
    >
      <Page
        title="Отчет контролера"
        primaryButtonNode={<BackButton onClick={backAction} />}
      >
        <Styled.PageWrapper>{body}</Styled.PageWrapper>
      </Page>
    </context.Provider>
  );
};
